module.exports = __webpack_public_path__ + "img/Menu-Get_10.c8931e7b.png";